$(document).ready(function () {
$(".dropdown-toggle-two").click(function(){
  $(".dropdown-menu-two").toggleClass("langopen");
});

$(".dropdown-toggle-one").click(function(){
  $(".dropdown-menu-one").toggleClass("langopen");
});
  
});  

$(document).ready(function(){
  $(".table-content-title").click(function(){
    $(".table-content-menu").toggle();
  });
  $(".table-content-menu a").click(function(){
    $(".table-content-menu").hide();
  });
});


document.addEventListener("DOMContentLoaded", function() {
    // Get the current page URL
    let currentUrl = window.location.href;

    // Construct the LinkedIn share URL with the correct subdomain
    let linkedInShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}`;

    // Select the LinkedIn share button by class
    let linkedInButton = document.querySelector(".share-buttons--linkedin");
    if (linkedInButton) {
      //alert(linkedInShareUrl);
        linkedInButton.href = linkedInShareUrl;
    }
});



  (function() {
    const path = window.location.pathname;

    const redirectPaths = [
      "/products/test",
      "/products/test-2",
      "/pages/test-html-section",
      "/collections/test"
    ];

    if (redirectPaths.includes(path)) {
      window.location.href = "/";
    }
  })();

  (function() {
    const redirects = {
      "/blogs/news/tagged/cnc-turning": "/blogs/news/top-features-to-look-for-in-an-online-cnc-machining-service",
      "/blogs/customer-testimonial/tagged/custom-machined-parts": "/blogs/customer-testimonial/productos-real-experience",
      "/blogs/customer-testimonial/tagged/custom-component-manufacturing": "/blogs/customer-testimonial/productos-real-experience",
      "/blogs/customer-testimonial/tagged/customer-testimonial": "/blogs/customer-testimonial/nuvision-biotherapies-experience",
      "/blogs/news/tagged/cnc-custom-machining": "/blogs/news/cnc-custom-machining-improves-product-development",
      "/blogs/news/tagged/on-demand-cnc-machining": "/blogs/news/cnc-custom-machining-improves-product-development", // Choosing one of the two
      "/blogs/news/tagged/custom-components": "/blogs/news/efficiency-benefits-of-outsourcing-wire-edm-services",
      "/blogs/news/tagged/cnc-machining-services": "/blogs/news/cnc-custom-machining-improves-product-development",
      "/blogs/news/tagged/cnc-machining-service": "/blogs/news/cnc-custom-machining-improves-product-development",
      "/blogs/news/tagged/custom-parts-manufacturing": "/blogs/news/efficiency-benefits-of-outsourcing-wire-edm-services",
      "/collections/robotics": "/pages/robotics"
    };

    const currentPath = window.location.pathname;

    if (redirects[currentPath]) {
      window.location.href = redirects[currentPath];
    }
  })();


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".table-content-menu a").forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      console.log("clicked:", this); // ✅ check if firing

      const targetId = this.getAttribute("href").substring(1);
      const block = document.getElementById(targetId);

      if (block) {
        const extraOffset = 50;
        const header = document.querySelector("header");
        const headerHeight = header ? header.offsetHeight : 0;

        const elementTop = block.getBoundingClientRect().top + window.scrollY;
        const scrollTo = elementTop - headerHeight - extraOffset;        

        window.scrollTo({
          top: scrollTo,
          behavior: "smooth"
        });
      }

      history.pushState(null, "", " ");
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a.navmenu-link').forEach(link => {
    if (link.textContent.trim() === 'Broschüre') {
      link.href = 'https://cdn.shopify.com/s/files/1/0574/4679/3277/files/Norck-Germany.pdf?v=1761754558';
    }
  });
});
